import { Pipe, PipeTransform } from '@angular/core';
import distanceInWords from 'date-fns/distance_in_words';
import format from 'date-fns/format';
import { isValidInput } from '../helper-functions';
import { DatePipeManager } from '../providers/date-pipe-manager';
/**
 * distance in words pipe by Aaron Sterling
 * takes as input an array of two dates
 * outputs the value of the date-fns DistanceInWords function
 */
export class DistanceBetweenDatesPipe implements PipeTransform {
/**
 * @param {?} manager
 */
constructor (private manager: DatePipeManager) {}
/**
 * @param {?} dates
 * @return {?}
 */
transform(dates: Array<string | number | Date>) {
    if (this.manager.secondsIncludedInDistance()) {
      return distanceInWords(dates[0], dates[1], {includeSeconds: true});
    } else {
      return distanceInWords(dates[0], dates[1], {includeSeconds: false});
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'distanceBetweenDates',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: DatePipeManager, },
];
}

function DistanceBetweenDatesPipe_tsickle_Closure_declarations() {
/** @type {?} */
DistanceBetweenDatesPipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DistanceBetweenDatesPipe.ctorParameters;
/** @type {?} */
DistanceBetweenDatesPipe.prototype.manager;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
